export default "__VITE_ASSET__CDqLqg6x__"